function LeadrsLogo(props: {
    size?: number;
    iconBg?: string;
    iconRing?: string;
    textColor?: string;
}) {
    const {
        size = 40,
        iconBg = '#141412',
        iconRing = '#ffffff',
        textColor = '#141412',
    } = props;

    return (
        <div className="flex items-center gap-3">
            <svg
                width={size}
                height={size}
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width="50" height="50" rx="13" fill={iconBg} />
                {/* Outer ring */}
                <ellipse cx="25" cy="25" rx="16" ry="8" fill={iconRing} />
                {/* Inner cutout */}
                <ellipse cx="25" cy="25" rx="8.5" ry="3.5" fill={iconBg} />
            </svg>
            <span
                className="font-geist text-2xl font-bold"
                style={{ color: textColor }}
            >
                Leadrs
            </span>
        </div>
    );
}

export default LeadrsLogo;
